import { LoadableAfterPaint } from '@confluence/loadable';

import { EllipsisPlaceholder } from '../src/EllipsisPlaceholder';

export const EllipsisDropdownComponent = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-EllipsisDropdown" */ '../src/EllipsisDropdown'))
			.EllipsisDropdownComponent,
	loading: EllipsisPlaceholder,
});

export { Buttons } from '../src/types';
